<template>
  <v-container class="px-5 my-5">
    <OrganizationTable
      :loading="loading"
      :table="organizationTable"
      :startDate="startDate"
      :endDate="endDate"
      :headers="headers"
      :statuses="statuses"
      @get-organizations="
        (startDate, endDate) => {
          if (startDate) {
            endDate = $moment().format('YYYY-MM-DD');
            getOrganizationsWithFilters(startDate, endDate);
          } else {
            getOrganizationsWithFilters();
          }
        }
      "
      @update-dates="(property, date) => updateDates(property, date)"
      @active-export-dialog="activeExportDialog()"
      @table-pagination="organizationTable.pagination = $event"
    />
    <DialogExport
      :module-options="['DashboardClients']"
      :startTime="startDate"
      :endTime="endDate"
      :state="organizationTable.state"
      :itemsPerPage="organizationTable.pagination.itemsPerPage"
      :search="organizationTable.search"
      :page="organizationTable.pagination.page"
      :organizationName="organizationTable.organizationName"
    />
    <DialogMessage />
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import DialogExport from "@/components/Downloads/DialogExport";
import DialogMessage from "@/components/Downloads/DialogMessage";
import organizationMixin from "@/mixins/organization";
import OrganizationTable from "@/components/DashboardClients/OrganizationTable";

export default {
  name: "DashboardClients",
  components: { DialogExport, DialogMessage, OrganizationTable },
  mixins: [organizationMixin],
  data() {
    return {
      organizationTable: {
        items: [],
        search: null,
        state: null,
        organizationName: null,
        total: 0,
        pagination: {
          sortBy: ["id"],
          sortDesc: [false],
          itemsPerPage: 10,
          mustSort: true,
          multiSort: false
        }
      },
      /* -- FILTERS -- */
      statuses: [
        this.getStatusObject("pending"),
        this.getStatusObject("active"),
        this.getStatusObject("past_due"),
        this.getStatusObject("suspended"),
        this.getStatusObject("canceled"),
        this.getStatusObject("deleted")
      ],
      /* ------------- */
      loading: false,
      initialDateEnv: process.env.INITIAL_DATE || "2015-01-01",
      startDate: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      endDate: this.$moment()
        .endOf("day")
        .format("YYYY-MM-DD"),
      organization: "",
      headers: [
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "id",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Organizacion",
          align: "center",
          sortable: true,
          value: "name",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "status",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Fecha de creacion",
          align: "center",
          sortable: false,
          value: "created_at",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "1er Donacion Unica",
          align: "center",
          sortable: true,
          value: "firstUniqueDonationDate",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Dias",
          align: "center",
          sortable: true,
          value: "daysUntilFirstUniqueDonation",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "1er Donacion Recurrente",
          align: "center",
          sortable: true,
          value: "firstRecurrentDonationDate",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Dias",
          align: "center",
          sortable: true,
          value: "daysUntilFirstRecurrentDonation",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Donaciones Unicas Totales",
          align: "center",
          sortable: true,
          value: "uniqueDonationsTotal",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Donaciones Recurrentes Totales",
          align: "center",
          sortable: true,
          value: "recurrentDonationsTotal",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Donaciones Unicas Este Mes",
          align: "center",
          sortable: true,
          value: "lastMonthUniqueDonationsTotal",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Donaciones Recurrentes Este Mes",
          align: "center",
          sortable: true,
          value: "lastMonthRecurrentDonationsTotal",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Automation Activo",
          align: "center",
          sortable: false,
          value: "hasAutomationActive",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Envios Totales",
          align: "center",
          sortable: true,
          value: "totalEmailSent",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Secuencias Activas",
          align: "center",
          sortable: true,
          value: "activeSequences",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Recurrent Payments",
          align: "center",
          sortable: true,
          value: "hasRecurrentPaymentsActive",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Recurrent Payments Total",
          align: "center",
          sortable: true,
          value: "recurrentPaymentsDonationsTotal",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Numero de Certificados Individuales",
          align: "center",
          sortable: true,
          value: "specificCampaignsCertificates",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Numero de Certificados Globales",
          align: "center",
          sortable: true,
          value: "globalCampaignsCertificates",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Landings Activo",
          align: "center",
          sortable: true,
          value: "hasLandingActive",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "n° de Landings Activas",
          align: "center",
          sortable: true,
          value: "activeLandings",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Fecha de Ultimo Newsletter",
          align: "center",
          sortable: true,
          value: "lastNewsletterDate",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Formularios Activos",
          align: "center",
          sortable: true,
          value: "activeForms",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Petitions Activo",
          align: "center",
          sortable: true,
          value: "hasPetitionsActive",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Autorresponders",
          align: "center",
          sortable: true,
          value: "autorresponders",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Crowdfunding",
          align: "center",
          sortable: true,
          value: "crowdfunding",
          class: "text-no-wrap blue--text text--darken-4"
        },
        {
          text: "Licencia",
          value: "name",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Monto de la licencia",
          value: "amount",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Moneda de la Licencia",
          value: "currency",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Frecuencia de la Licencia",
          value: "frequency",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Licencia de Automation",
          value: "automation",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Monto de Automation",
          value: "automation_amount",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Moneda de Automation",
          value: "automation_currency",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Licencia de Special Projects",
          value: "special_projects",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Monto Special Projects",
          value: "special_projects_amount",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        },
        {
          text: "Moneda de Special Projects",
          value: "special_projects_currency",
          class: "text-no-wrap blue--text text--darken-4",
          width: "",
          sortable: true
        }
      ]
    };
  },
  created() {
    this.startDate = this.startDate
      ? this.startDate
      : this.$moment(this.initialDateEnv).format("YYYY-MM-DD");
  },
  computed: {
    ...mapState({
      organizationsData: ({ organizationsData: { organizationsData } }) =>
        organizationsData,
      organizationsTotal: ({ organizationsTotal: { organizationsTotal } }) =>
        organizationsTotal
    }),
    ...mapGetters({
      organizationsData: "dashboardClients/organizationsData",
      organizationsTotal: "dashboardClients/organizationsTotal"
    })
  },
  watch: {
    "organizationTable.pagination": {
      handler() {
        this.getOrganizationsWithFilters();
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({
      getData: "dashboardClients/getData",
      exportData: "downloads/exportData"
    }),
    ...mapMutations({
      toggleDialogExport: "downloads/toggleDialogExport"
    }),
    updateDates(property, date) {
      this[property] = date;
      this.getOrganizationsWithFilters();
    },
    async getOrganizationsWithFilters(startDate, endDate) {
      const initialDate = !startDate ? this.startDate : startDate;
      const finalDate = !endDate ? this.endDate : endDate;
      this.startDate = initialDate;
      this.loading = true;
      let { sortBy, sortDesc = false } = this.organizationTable.pagination;
      const { page, itemsPerPage } = this.organizationTable.pagination;
      if (Array.isArray(sortBy)) {
        [sortBy] = sortBy;
      }
      if (Array.isArray(sortDesc)) {
        [sortDesc] = sortDesc;
      }
      await this.getData({
        startDate: initialDate,
        endDate: finalDate,
        search: this.organizationTable.search,
        group: this.organizationTable.group,
        state: this.organizationTable.state
          ? this.organizationTable.state
          : null,
        page,
        rowsPerPage: itemsPerPage,
        sortBy: sortBy || "id",
        descending: sortDesc,
        organizationName: this.organizationTable.organizationName
      });
      this.loading = false;
      this.organizationTable.items = this.organizationsData;
      this.organizationTable.total = Number.parseInt(
        this.organizationsTotal,
        10
      );
    },
    activeExportDialog() {
      this.toggleDialogExport(true);
    }
  }
};
</script>
